module.exports = __webpack_public_path__ + "img/NL830.69b3cf3f.png";